// extracted by mini-css-extract-plugin
export default {"root":"styles_root__NzR-A","label":"styles_label__xOpy9","selected":"styles_selected__mT+gH","title":"styles_title__lToO+"};